















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { MetaInfo } from 'vue-meta';

import { db, DocumentReference } from '@/firebase';

import AvatarForm from '@/components/forms/AvatarForm.vue';
// import ActivationList from '@/components/ActivationList.vue';
import CustomerProfileForm from '@/components/forms/CustomerProfileForm.vue';
import CustomerAdminForm from '@/components/forms/CustomerAdminForm.vue';

export default Vue.extend( {
	components: {
		AvatarForm,
		// ActivationList,
		CustomerProfileForm,
		CustomerAdminForm
	},
	head(): MetaInfo {
		return {
			title: this.$t( 'views.customer-settings.customer-settings' ).toString()
		};
	},
	computed: {
		...mapGetters( [ 'customer' ] ),
		resource(): DocumentReference {
			return db.collection( 'customers' ).doc( this.customer.id );
		},
		activationsCollection() {
			return db.collection( 'customers' ).doc( this.customer.id ).collection( 'activations' );
		}
	}
} );
